import React from "react";
import { INotificationProvider } from "@contexts/notification/types";
import {
  showNotification,
  updateNotification,
  hideNotification,
} from "@mantine/notifications";
import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX, IconRotateClockwise2, IconCheck } from "@tabler/icons-react";
import { RingCountdown } from "@components";

export const notificationProvider = (): INotificationProvider => {
  const activeNotifications: string[] = [];

  const isNotificationActive = (key?: string) => {
    return activeNotifications.includes(key as string);
  };

  const addNotification = (key?: string) => {
    if (key) {
      const index = activeNotifications.indexOf(key);
      if (index === -1) {
        activeNotifications.push(key);
      }
    }
  };

  const removeNotification = (key?: string) => {
    if (key) {
      const index = activeNotifications.indexOf(key);
      if (index > -1) {
        activeNotifications.splice(index, 1);
      }
    }
  };

  const notificationProvider: INotificationProvider = {
    open: ({ message, description, type, undoableTimeout, key, cancelMutation }) => {
      if (type === "progress") {
        if (isNotificationActive(key)) {
          updateNotification({
            id: key!,
            title: message,
            message: description && description.trim() !== "" ? (
              <Text size="sm" style={{ whiteSpace: 'pre-line' }}>{description}</Text>
            ) : undefined,
            styles: {
              root: {
                paddingLeft: "8px",
                paddingTop: "0px",
                paddingBottom: "0px",
                "&::before": { display: "none" },
              },
            },
            withCloseButton: false,
            autoClose: false,
          });
        } else {
          addNotification(key);
          showNotification({
            id: key,
            title: message,
            message: description && description.trim() !== "" ? (
              <Group position="apart" noWrap>
                <Group spacing="xs" position="center">
                  <RingCountdown undoableTimeout={undoableTimeout ?? 0} />
                  <Text size="sm" style={{ whiteSpace: 'pre-line' }}>{description}</Text>
                </Group>
                <ActionIcon
                  variant="default"
                  onClick={() => {
                    cancelMutation?.();
                    if (key) {
                      removeNotification(key);
                      hideNotification(key);
                    }
                  }}
                >
                  <IconRotateClockwise2 size={18} />
                </ActionIcon>
              </Group>
            ) : (
              <Group position="apart" noWrap>
                <Group spacing="xs" position="center">
                  <RingCountdown undoableTimeout={undoableTimeout ?? 0} />
                  <Text>{message}</Text>
                </Group>
                <ActionIcon
                  variant="default"
                  onClick={() => {
                    cancelMutation?.();
                    if (key) {
                      removeNotification(key);
                      hideNotification(key);
                    }
                  }}
                >
                  <IconRotateClockwise2 size={18} />
                </ActionIcon>
              </Group>
            ),
            styles: {
              root: {
                paddingLeft: "8px",
                paddingTop: "0px",
                paddingBottom: "0px",
                "&::before": { display: "none" },
              },
            },
            withCloseButton: false,
            autoClose: false,
          });
        }
      } else {
        if (isNotificationActive(key)) {
          updateNotification({
            id: key!,
            color: type === "success" ? "green" : "red",
            icon:
              type === "success" ? (
                <IconCheck size={18} />
              ) : (
                <IconX size={18} />
              ),
            title: message,
            message: description && description.trim() !== "" ? <Text size="sm" style={{ whiteSpace: 'pre-line' }}>{description}</Text> : undefined,
            autoClose: 5000,
          });
        } else {
          addNotification(key);
          showNotification({
            color: type === "success" ? "green" : "red",
            icon:
              type === "success" ? (
                <IconCheck size={18} />
              ) : (
                <IconX size={18} />
              ),
            title: message,
            message: description && description.trim() !== "" ? <Text size="sm" style={{ whiteSpace: 'pre-line' }}>{description}</Text> : undefined,
            onClose: () => {
              removeNotification(key);
            },
            autoClose: 5000,
          });
        }
      }
    },
    close: (key) => {
      removeNotification(key);
      hideNotification(key);
    },
  };

  return notificationProvider;
};
